import React from "react";
import { isFunction } from "../../../../../Libs/CustomMethods/customMethods";
import { Button } from "reactstrap";

const SendButton = ({ onClick, activeSubmit }) => {
  return (
    <Button
      className={`d-flex align-items-center chat-send waves-light ${
        !activeSubmit ? "isDisabled" : ""
      }`}
      onClick={isFunction(onClick) && onClick}
      type="submit"
      color="primary"
      disabled={!activeSubmit}
    >
      <i className="mdi mdi-send"></i>
    </Button>
  );
};
export default SendButton;
